import React, { useEffect, useState, useContext } from "react";
import dayjs from "dayjs";

//MUI
import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import ConfirmDelete from "./ConfirmDelete";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Avatar from '@mui/material/Avatar';

//components
import CustomButton from "../Common/CustomButton";
import ThreeWaySwitch from "../Common/ThreeWaySwitch";

//assets
import DefaultThumbnail from "../../assets/images/thumbnail1.png";

//utils
import { formatDateWithTime } from "../../utils/helpers";

//context
import { AuthContext } from "../../contexts/AuthContext";
import { AlertContext } from "../../contexts/AlertContext";

//api
import { addAttachmentComment, getCommentsList, deleteComment } from "../../apis/taskManagement";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .heading": {
    padding: "0.5rem",
    borderBottom: "1px solid #EAEAEA",
    "& .text_style": {
      fontWeight: "600",
      fontSize: "18px",
    },
  },
  "& .main": {
    width: "100%",
    height: "450px",
    maxHeight: "450px",
    display: "flex",
    "& .left-container": {
      // width: "24%",
      width: "35%",
      height: "450px",
      maxHeight: "450px",
      borderRight: "1px solid #e5e5e5",
      "& .image_container": {
        width: `cal(100% - 0.3rem)`,
        height: "415px",
        maxHeight: "415px",
        overflowY: "auto",
        // justifyContent: "center",
        // alignItems: "center",
        padding: "0.5rem",
        '&::-webkit-scrollbar': {
          width: '0.3em',
          height: '0.3em'
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#cccccc',
        },
        "& .left-img-container": {
          display: "flex",
          flexWrap: "wrap",
          gap: "0.75rem",
        },
        "& .img_block": {
          borderRadius: "6px",
          display: "flex",
          flexDirection: "column",
        },
        "& img": {
          background: "#F2F2F2",
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "4px",
        },
        "& .selected": {
          border: "2px solid #253A6A",
        },
        "& .not_selected": {
          // border: "2px solid #F2F2F2",
        },
        "& .status_style": {
          display: "flex",
          height: "25px",
          justifyContent: "center",
          alignItems: "center",
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
        },
      },
      "& .platform_container": {
        "& .platform_tabs": {
          margin: "0 0.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          borderBottom: "1px solid #E5E5E5",
          gap: "0.5rem",
          "& .tab": {
            "& .tab_btn": {
              paddingBottom: 0,
              paddingRight: "1.5rem",
              borderRadius: 0,
              color: "#1B1C1E",
              fontWeight: "400",
            },
            "& .actv_tab_btn": {
              borderBottom: "2px solid #00A0E3",
              borderRadius: 0,
              fontWeight: "600",
            },
          },
        },
      },
    },
    "& .right-container": {
      width: "65%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0.5rem 1rem",
      gap: "0.5rem",
      overflowY: "scroll",
      overflowX: "hidden",
      "&::-webkit-scrollbar": {
        width: "0.4em",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#9A9A9A",
        borderRadius: "30px",
      },
      "& .switch_container": {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
      },
      "& .img-container": {
        // border: "1px solid red",
        height: "315px",
        width: "100%",
        "& .img_block": {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        "& img": {
          border: "1px solid #F2F2F2",
          padding: "1rem",
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          // objectFit: "cover",
          background: "#F2F2F2",
          borderRadius: "10px",
        },
      },
      "& .video_container": {
        width: "100%",
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "0.5rem",
        borderRadius: "10px",
        background: "#F2F2F2",
        padding: "1rem",
        "& .video_block": {
          width: "100%",
          height: "100%",
          objectFit: "contain",
          borderRadius: "10px",
        },
      },
      "& .file_basic_details": {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        "& .detail_block": {
          width: "100%",
          display: "flex",
          alignItems: "center",
          "& .type": {
            width: "18%",
            color: "#939090",
            fontSize: "14px",
          },
          "& .info": {
            // width: "82%",
            color: "#4F4F4F",
            fontSize: "14px",
          },
        },
      },
      "& .comments_container": {
        width: "100%",
        "& .new_comm_script": {
          width: "100%",
          padding: "0.5rem 0.2rem 0.5rem 0",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          "& .avt_container": {
            width: "8%",
            paddingLeft: "0.5rem",
            alignSelf: "flex-start",
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
          },
          "& textarea": {
            border: "1px solid #b3b3b3",
            borderRadius: "4px",
            fontFamily: theme.typography.fontFamily,
            "&:focus": {
              outlineColor: "#00A0E3",
            }
          },
        },
        "& .comment_block": {
          width: "100%",
          padding: "0.5rem 0.2rem 0.5rem 0.5rem",
          // borderBottom: "1px solid #C4C4C4",
          // paddingBottom: "0.5rem",
          "& .header_style_script": {
            marginBottom: "0.5rem",
            "& .header_with_edit": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "& .headers_style": {
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
              },
            },
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
            "& .name_style": {
              color: "#1B1C1E",
              fontWeight: "600",
              fontSize: "16px",
            },
            "& .date_style": {
              color: '#939090',
              fontSize: "14px",
            },
          },
          "& .header_style_script_old": {
            // display: "flex",
            // gap: "1rem",
            // alignItems: "center",
            marginBottom: "1px",
            overflow: "hidden",
            "& .header_with_edit": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "& .headers_style": {
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
              },
            },
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
            "& .name_style": {
              color: "#1B1C1E",
              fontWeight: "600",
              fontSize: "16px",
            },
            "& .date_style": {
              color: '#939090',
              fontSize: "14px",
            },
          },
          "& .edit_button_style": { // can be removed
            display: "flex",
            justifyContent: "flex-end",
            "& .edit_comm_style": {
              height: "22px",
              fontSize: "11px",
            },
          },
          "& .comments_display_container": {
            width: "100%",
            display: "flex",
            // gap: "0.5rem",
            "& .empty_span": {
              width: "8%",
            },
            "& .comment_style_container": {
              width: "92%",
              border: "1px solid #E5E5E5",
              borderRadius: "4px",
              padding: "0.3rem",
              "& .comment_style": {
                width: "90%",
                color: "#4F4F4F",
                fontSize: "13px",
              },
            },
          },
          "& .comment_actions_container": {
            width: "100%",
            display: "flex",
            // gap: "0.5rem",
            paddingTop: "0.3rem",
            "& .empty_span": {
              width: "8%",
            },
            "& .btns_container": {
              display: "flex",
              gap: "8px",
              "& .edit_btn": {
                padding: "0 3px 3px 0",
                minWidth: "40px",
                display: "flex",
                justifyContent: "flex-start"
              },
              "& .del_btn": {
                padding: "0 3px 3px 0",
                minWidth: "50px",
                display: "flex",
                justifyContent: "flex-start"
              },
              "& .btn_txt": {
                color: "#787575",
                fontSize: "13px",
                fontWeight: "400",
              },
            }
          },
          "& .link_style": {
            color: "blue",
            fontSize: "16px",
            "&:hover": {
              color: "red",
            },
          },
        },
      },
      "& .empty_info": {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
    },
    "& .err_msg": {
      width: "100%",
      padding: "2rem 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "red",
    }
  },
  "& .option_input_comm": {
    width: "100%",
    display: "flex",
    "& .empty_span": {
      width: "8%",
    },
    "& .MuiInputBase-root": {
      height: "36px",
    },
    "& textarea": {
      border: "1px solid #00A0E3",
      borderRadius: "4px",
      padding: "0.3rem",
      fontFamily: theme.typography.fontFamily,
      "&:focus": {
        outlineColor: "#00A0E3",
      }
    },
  },
  "& .bottom_container": {
    borderTop: "1px solid #EAEAEA",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.5rem",
    "& .btn_styl": {
      borderRadius: "10px",
    },
    "& .del_style": {
      color: "#FFFFFF",
      background: "#FF5252",
      borderRadius: "10px",
    }
  }
}));

const pattern = /\.mp4/i;
const patternAudio = /\.mp3/i;


// For images status background color 
const statusBgColor = {
  "1": "#D4E7F6",
  "2": "#CAF0CC",
  "3": "#FABBC3",
};

const statusNumberToValue = {
  "1": "Pending",
  "2": "Approved",
  "3": "Rejected",
};

const statusToToggleValue = {
  "1": "middle",
  "2": "left",
  "3": "right",
};

const toggleToStatusValue = {
  "middle": 1,
  "left": 2,
  "right": 3,
};

const subcategoryMapping = {
  "image": "Image",
  "video": "Video",
  "reel": "Reel",
  "thumbnail": "Thumbnail",
};

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  const initials = name.split(' ').map(word => word[0]).join('');
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: initials,
  };
}

const ShowAttachments = (props) => {
  const { onClose, selectedValue, open, taskId, attachments, selectedAttachment, getAttachmentsData, selectedAttachmentInfo, attachmentPlatform } = props;
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const [audio, setAudio] = useState("");
  const [platform, setPlatform] = useState("");
  const [selected, setSelected] = useState(selectedAttachment);
  const [selectedInfo, setSelectedInfo] = useState(selectedAttachmentInfo);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openConfirmCommentDelete, setOpenConfirmCommentDelete] = useState(false);
  const [toggleValue, setToggleValue] = useState("");
  const [comment, setComment] = useState("");
  const [commentsData, setCommentsData] = useState([]);
  const [commentAction, setCommentAction] = useState(false);
  const [commentId, setCommentId] = useState("");
  const [commentToDelete, setCommentToDelete] = useState("");
  const [editCommentVal, setEditCommentVal] = useState("");
  const [loader, setLoader] = useState(false);
  const { user } = useContext(AuthContext);
  const { showAlert } = useContext(AlertContext);

  const handleClickConfirmDelete = () => {
    setOpenConfirmDelete(true);
  };

  const handleDialogCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
  };

  const handleClickConfirmCommentDelete = (val) => {
    setCommentToDelete(val);
    setOpenConfirmCommentDelete(true);
  };

  const handleDialogCloseConfirmCommentDelete = () => {
    setOpenConfirmCommentDelete(false);
  };

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handlePlatformChange = (value) => {
    setPlatform(value);
  };

  const handleFileStatusChange = async (value) => {
    setToggleValue(value);
    await getAttachmentsData(taskId, "edit", selectedInfo?.pk, toggleToStatusValue[value]);
    getAttachmentsData(taskId, "", selectedInfo?.pk, "", platform);
    // // setVideo("");
    // // setImage("");
    // // setAudio("");
  };

  const handleClick = (item) => {
    setImage("");
    setVideo("");
    setAudio("");
    if (pattern.test(item?.file_urls[0])) {
      setImage("");
      setVideo(item?.file_urls[0]);
      setAudio("");
    } else if (patternAudio.test(item?.file_urls[0])) {
      setImage("");
      setVideo("");
      setAudio(item?.file_urls[0]);
    } else {
      setImage(item?.file_urls[0]);
      setVideo("");
      setAudio("");
    }
    setSelected(item?.file_urls[0]);
    setToggleValue(statusToToggleValue[`${item?.approved_status}`]);
    setSelectedInfo(item);
    getCommentsData(item?.pk);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    let url = "";
    if (image) {
      url = image;
    } else if (audio) {
      url = audio;
    } else {
      url = video;
    }
    link.href = url;
    link.click();
  };

  const handleFileDelete = async () => {
    await getAttachmentsData(taskId, "del", selectedInfo?.pk);
    setLoader(true);
    let newPlatform = await getAttachmentsData(taskId, "info", selectedInfo?.pk, platform);
    setPlatform(newPlatform);
    setVideo("");
    setImage("");
    setAudio("");
    handleDialogCloseConfirmDelete();
    setLoader(false);
  };

  const handleTabClick = (val) => {
    setLoader(true);
    setPlatform(val);
    const firstAttachment = attachments?.[`${val}`]?.[0];
    if (firstAttachment) {
      setTimeout(() => {
        handleClick(firstAttachment);
        setLoader(false);
      }, 300);
    } else {
      setSelected("");
      setSelectedInfo("");
      setImage("");
      setVideo("");
      setAudio("");
    }
  };

  const getCommentsData = async (id) => {
    if (id) {
      const { data, error } = await getCommentsList(id, "attachment");
      if (error) {
        if (error.status === 401) {
          return;
        } else if (error.status === 404) {
          // alert("No users available for your state");
          return;
        } else {
          // alert("Couldn't fetch the data");
          return;
        }
      }
      setCommentsData(data);
    }
  };

  const handleCommentDelete = async () => {
    const { error } = await deleteComment(
      selectedInfo.pk,
      commentToDelete?.id,
      "attachment"
    );
    if (error) {
      showAlert("Something went wrong", "error");
      return;
    }
    showAlert("Comment Deleted", "success");
    getCommentsData(selectedInfo.pk); 
    setCommentToDelete("");
    handleDialogCloseConfirmCommentDelete();
  };

  const handleCommentAction = (val) => {
    if (val === "") {
      setCommentAction(false);
      setCommentId("");
      setEditCommentVal("");
      return;
    }
    setCommentAction(prevState => !prevState);
    setCommentId(val?.id);
    setEditCommentVal(val?.text);
  };

  const handleFinalCommentSubmit = async (type) => {
    let text = "";
    text = comment;
    let action = "create";
    if (type === "edit") {
      action = "edit";
      text = editCommentVal;
    }
    const { error } = await addAttachmentComment(
      selectedInfo.pk,
      text,
      "comment",
      action,
      commentId,
    );
    if (error) {
      showAlert("Something went wrong", "error");
      return;
    }
    showAlert("Comment Edited", "success");
    setComment("");
    if (commentAction) {
      setCommentAction(false);
      setCommentId("");
      setEditCommentVal("");
    }
    getCommentsData(selectedInfo.pk);
  }

  useEffect(() => {
    if (platform && attachments?.[platform]) {
      attachments[platform].forEach((item) => {
        if (item?.file_urls[0] && !pattern.test(item.file_urls[0]) && !patternAudio.test(item.file_urls[0])) {
          const img = new Image();
          img.src = item.file_urls[0];
        }
      });
    }
  }, [attachmentPlatform, attachments]);

  useEffect(() => {
    setPlatform(attachmentPlatform);
    if (selectedAttachment) {
      handleClick(selectedAttachmentInfo);
    }
  }, [selectedAttachment, attachments, attachmentPlatform]);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={"md"}
      sx={{
        "& .MuiDialog-scrollPaper": {

        },
        "& .MuiPaper-root": {
          borderRadius: "6px",
          border: "1px solid #F3BF04",
        }
      }}
    >
      <Container>
        <div className="heading">
          <Typography className="text_style">Content Approval</Typography>
        </div>

        <div className="main">
          {attachments ?
            <>
              <div className="left-container">
                <div className="platform_container">
                  <div className="platform_tabs">
                    <div className="tab">
                      <CustomButton
                        className={platform === "facebook" ? "tab_btn actv_tab_btn" : "tab_btn"}
                        onClick={() => handleTabClick("facebook")}
                      >
                        Facebook
                      </CustomButton>
                    </div>
                    <div className="tab">
                      <CustomButton
                        className={platform === "instagram" ? "tab_btn actv_tab_btn" : "tab_btn"}
                        onClick={() => handleTabClick("instagram")}
                      >
                        Instagram
                      </CustomButton>
                    </div>
                    <div className="tab">
                      <CustomButton
                        className={platform === "youtube" ? "tab_btn actv_tab_btn" : "tab_btn"}
                        onClick={() => handleTabClick("youtube")}
                      >
                        YouTube
                      </CustomButton>
                    </div>
                  </div>
                </div>
                <div className="image_container">
                  {!loader ?
                    <div className="left-img-container">
                      {(attachments && platform) && attachments?.[`${platform}`].map((item, index) => {
                        if (item !== "[]" && item !== null) {
                          const isVideoOrAudio = /\.mp4/i.test(item?.file_urls[0]) || /\.mp3/i.test(item?.file_urls[0]);
                          const imageSrc = isVideoOrAudio ? DefaultThumbnail : item?.file_urls[0];
                          return (
                            <div
                              className={selected === item?.file_urls[0] ? "img_block selected" : "img_block not_selected"}
                            >
                              <img
                                src={imageSrc}
                                alt="files"
                                loading="lazy"
                                objectFit="contain"
                                onClick={() => handleClick(item)}
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  maxWidth: "120px",
                                  // padding: "0.5rem",
                                  objectFit: "cover"
                                }}
                              />
                              <div className="status_style" style={{ backgroundColor: statusBgColor[`${item?.approved_status}`] }}>
                                <Typography
                                  sx={{
                                    color: "#4F4F4F",
                                    fontSize: "13px",
                                  }}
                                >
                                  {statusNumberToValue[`${item?.approved_status}`]}
                                </Typography>
                              </div>
                            </div>
                          )
                        }
                      })}
                    </div> :
                    <></>
                  }
                </div>
              </div>
              <div className="right-container">
                {selectedInfo ?
                  <>
                    <div className="switch_container">
                      {user?.is_approver ?
                        <ThreeWaySwitch
                          value={toggleValue}
                          setValue={handleFileStatusChange}
                          leftSideText="Approve"
                          rightSideText="Reject"
                        /> :
                        <></>
                      }
                    </div>
                    <Box className="img-container">
                      <div className="img_block">
                        {image ?
                          <img
                            src={image}
                            alt="file"
                            objectFit="contain"
                            style={{
                              width: "80%",
                              height: "100%",
                              maxWidth: "100%",
                              padding: "0.5rem",
                            }}
                          /> :
                          <></>
                        }
                        {video ?
                          <div className="video_container">
                            <video className="video_block" src={video} type="video/mp4" controls>
                            </video>
                          </div> :
                          <></>
                        }
                        {audio ?
                          <div className="video_container">
                            <audio src={audio} controls />
                          </div> :
                          <></>
                        }
                      </div>
                    </Box>
                    <div className="file_basic_details">
                      <div className="detail_block">
                        <Typography className="type">Type:</Typography>
                        <Typography className="info">{subcategoryMapping[`${selectedInfo?.subcategory}`]}</Typography>
                      </div>
                      <div className="detail_block">
                        <Typography className="type">Status:</Typography>
                        <Typography
                          className="info"
                          sx={{
                            background: statusBgColor[`${selectedInfo?.approved_status}`],
                            padding: "0.2rem 0.8rem",
                            borderRadius: "15px",
                          }}
                        >
                          {statusNumberToValue[`${selectedInfo?.approved_status}`]}
                        </Typography>
                      </div>
                      <div className="detail_block">
                        <Typography className="type">Upload on:</Typography>
                        <Typography className="info">{formatDateWithTime(selectedInfo?.created_at)}</Typography>
                      </div>
                    </div>
                    <div className="comments_container">
                      <div className="new_comm_script">
                        <div className="avt_container">
                          <Avatar {...stringAvatar(`${user?.name}`)} />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "3px",
                          }}
                        >
                          <TextareaAutosize
                            minRows={2}
                            style={{
                              width: "100%",
                              padding: "0.3rem"
                            }}
                            name="comment"
                            value={comment}
                            placeholder={`Add a new comment`}
                            onChange={(e) => setComment(e.target.value)}
                          // onClick={() => handleFinalCommentSubmit(tabSeledted)}
                          // onKeyDown={handleCommentSubmit}
                          />
                          <CustomButton
                            variant="text"
                            onClick={() => handleFinalCommentSubmit("add")}
                            sx={{
                              padding: "0 3px 3px 0",
                              minWidth: "40px",
                              width: "40px",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#787575",
                                fontSize: "13px",
                                fontWeight: "400",
                                textTransform: "none",
                              }}
                            >
                              Add
                            </Typography>
                          </CustomButton>
                        </div>
                      </div>
                      {commentsData.map(item => {
                        return (
                          <div className="comment_block">
                            <div className="header_style_script_old">
                              <div className="header_with_edit">
                                <div className="headers_style">
                                  <Avatar {...stringAvatar(`${item?.posted_by?.name}`)} />
                                  <Typography className="name_style">{item?.posted_by?.name}</Typography>
                                  <Typography className="date_style">{dayjs(item?.created_at).format('DD-MMM-YYYY')}</Typography>
                                </div>
                              </div>
                            </div>
                            {
                              commentAction && commentId === item?.id ?
                                <>
                                  <div className="option_input_comm">
                                    <span className="empty_span"></span>
                                    <TextareaAutosize
                                      minRows={3}
                                      style={{
                                        width: "92%"
                                      }}
                                      name="comment"
                                      value={editCommentVal}
                                      onChange={(e) => setEditCommentVal(e.target.value)}
                                    // onKeyDown={handleCommentSubmit}
                                    />
                                  </div>
                                </> :
                                <div className="comments_display_container">
                                  <span className="empty_span"></span>
                                  <div className="comment_style_container">
                                    <Typography className="comment_style">{item?.text}</Typography>
                                  </div>
                                </div>
                            }
                            <div className="comment_actions_container">
                              <span className="empty_span"></span>
                              <div className="btns_container">
                                {commentAction && commentId === item?.id ?
                                  <CustomButton
                                    className="edit_btn"
                                    onClick={() => handleFinalCommentSubmit("edit")}
                                  >
                                    <Typography className="btn_txt">Save Changes</Typography>
                                  </CustomButton> :
                                  <CustomButton
                                    onClick={() => handleCommentAction(item)}
                                    className="edit_btn"
                                  >
                                    <Typography className="btn_txt">Edit</Typography>
                                  </CustomButton>
                                }
                                {commentId !== item?.id ?
                                  <CustomButton
                                    onClick={() => handleClickConfirmCommentDelete(item)}
                                    className="del_btn"
                                  >
                                    <Typography className="btn_txt">Delete</Typography>
                                  </CustomButton> :
                                  <CustomButton
                                    onClick={() => handleCommentAction("")}
                                    className="del_btn"
                                  >
                                    <Typography className="btn_txt">Discard</Typography>
                                  </CustomButton>
                                }
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </>
                  :
                  <div className="empty_info">
                    <Typography>No Data</Typography>
                  </div>
                }
              </div>
            </> :
            <div className="err_msg">
              <Typography>No attachments added</Typography>
            </div>
          }
        </div>
        <div className="bottom_container">
          <CustomButton
            variant="contained"
            className="btn_styl"
            onClick={handleClose}
          >
            Close
          </CustomButton>
          {attachments ?
            <CustomButton
              variant="contained"
              className="del_style"
              onClick={handleClickConfirmDelete}
            >
              Delete
            </CustomButton> :
            <></>
          }
          {attachments ?
            <CustomButton
              variant="contained"
              className="btn_styl"
              onClick={handleDownload}
            >
              Download
            </CustomButton> :
            <></>
          }
        </div>
      </Container>
      {openConfirmDelete ?
        <ConfirmDelete
          open={openConfirmDelete}
          onClose={handleDialogCloseConfirmDelete}
          onConfirm={handleFileDelete}
          fileType={"file"}
        /> :
        <></>
      }
      {openConfirmCommentDelete ?
        <ConfirmDelete
          open={openConfirmCommentDelete}
          onClose={handleDialogCloseConfirmCommentDelete}
          onConfirm={handleCommentDelete}
          fileType={"comment"}
        /> :
        <></>
      }
    </Dialog>
  );

};

export default ShowAttachments;